module.exports = __webpack_public_path__ + "static/media/smile-squint-wink-alt.bf31f451.svg";